
const router = {
     //path: '/index',
    children: [
      {//系统公告
        path: 'index',
        name: 'index',
        label: '首页',
        translate:'layout_home'
      },
      // {
      //   path: 'wantOrder',
      //   name: 'wantOrder',
      //   label: '我的订单',
      //   translate:'layout_wddd'
      // },
      {
        path: 'ourServer',
        name: 'ourServer',
        label: '验货服务',
        translate:'layout_wmdfw'
      },
      {
        path: '/purchase',
        name: 'purchase',
        label: ' 采购信息广场',
        translate:'layout_purchase'
      },
      {
        path: 'aboutUs',
        name: 'aboutUs',
        label: '关于平台',
        translate:'layout_aywm'
      }
    ]
}
export default router